import { makeStyles } from '@material-ui/core/styles';
import { InfiniteScrollGrid } from '@roc/feature-app-core';
import {
  useBorrowerLoansRoutes,
  useBorrowerLoansStore,
} from '@roc/feature-borrower-loans';
import { DataGrid, GridColumnProps } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import {
  borrowerLoansColumns,
  borrowerLoansFrameworkComponents,
} from './borrowerLoansMyLoansGrid';

const useStyles = makeStyles(theme => ({
  paginationBar: {
    border: 'none',
    borderTop: '1px solid #eee',
    padding: 8,
    background: '#fafafa',
  },
}));

const BorrowerLoansPipelineLoansColumns: GridColumnProps[] = [
  {
    field: 'dealid',
    headerName: 'Loan Id',
    maxWidth: 120,
    cellRenderer: 'loanIdCellRenderer',
  },
  {
    field: 'dealName',
    headerName: 'Deal Name',
    minWidth: 200,
    cellRenderer: 'dealNameCellRenderer',
  },
  {
    field: 'status',
    headerName: 'Status',
    maxWidth: 170,
    cellRenderer: 'statusCellRenderer',
  },
  {
    field: 'loanSubType',
    headerName: 'Loan Type',
    cellRenderer: 'loanSubTypeCellRenderer',
    maxWidth: 300,
  },
  {
    field: 'submissionDate',
    headerName: 'Submission Date',
    maxWidth: 185,
  },
  {
    field: 'closingDate',
    headerName: 'Closing Date',
    maxWidth: 185,
  },
];

export const BorrowerLoansPipelineLoansGrid = observer(() => {
  const classes = useStyles();
  const { borrowerLoansStore } = useBorrowerLoansStore();
  const { borrowerPipelineLoansGridStore } = borrowerLoansStore;
  const gridStore = borrowerPipelineLoansGridStore;
  const {
    borrowerLoanRoutesConfig,
    platformBorrowerLoanRoutesConfig,
  } = useBorrowerLoansRoutes();

  useEffect(() => {
    gridStore.resetAndFetchGridData();
  }, []);

  return (
    <InfiniteScrollGrid
      columns={borrowerLoansColumns}
      store={gridStore}
      frameworkComponents={borrowerLoansFrameworkComponents(
        borrowerLoanRoutesConfig,
        platformBorrowerLoanRoutesConfig
      )}
      paginationBarClassName={classes.paginationBar}
      domLayout="autoHeight"
    />
  );
});
